import { render, staticRenderFns } from "./pointsExchangeGoodsManage.vue?vue&type=template&id=0c48a62a"
import script from "./pointsExchangeGoodsManage.vue?vue&type=script&lang=js"
export * from "./pointsExchangeGoodsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports